import { render, staticRenderFns } from "./ObservatoryList.vue?vue&type=template&id=4b798254&scoped=true&"
import script from "./ObservatoryList.vue?vue&type=script&lang=js&"
export * from "./ObservatoryList.vue?vue&type=script&lang=js&"
import style0 from "./ObservatoryList.vue?vue&type=style&index=0&id=4b798254&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b798254",
  null
  
)

export default component.exports